import React, { memo, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { useLocation } from "react-router-dom"; -- JK : Removed Unused
import moment from "moment";
import DatePicker from "react-datepicker";
// import axios from "axios"; -- JK : Removed Unused
import $ from "jquery";

import imgselect from "../../assets/images/select_box.png";
import Pagination from "../Pagination/Pagination";
import Loader from "../resuableComponent/loader";
import EditTaskPopup from "./EditTaskPopup";
import TaskNAssignee from "./components/Task_n_Assignee";

import RemediationActionButton from "../common/RemediationActionButton";

import {
  getOverviewList,
  removeTicket,
  updateTicket,
} from "../../actions/remediationMode";
// import { API_URL } from "../../utils/constant"; -- JK : Removed Unused

const RemediationOverview = () => {
  //const [PageSize, setPerPage] = useState(10); -- JK : Removed Unused
  const dispatch = useDispatch();
  // const myRef = useRef(null); -- JK : Removed Unused
  const [category, setCategory] = useState("all");
  // const [users, setUsers] = useState([]);  -- JK : Removed Unused
  const auth = useSelector((state) => state?.auth?.user);
  //const location = useLocation(); -- JK : Removed Unused
  const id = useSelector((state) => {
    return (
      state?.summary?.localClient?._id ||
      state?.summary?.clients?.data?.[0]?._id
    );
  });
  const list = useSelector((state) => {
    return state?.remediationMode?.list?.data;
  });
  const pagination = useSelector(
    (state) => state?.remediationMode?.list?.data?.pagination
  );
  const [page, setPage] = useState(1);
  // const [rating, setRating] = useState(""); -- JK : Removed Unused
  // const [priority, setPriority] = useState(""); -- JK : Removed Unused
  // const [status, setStatus] = useState(""); -- JK : Removed Unused
  // const [totalItems, setTotalItems] = useState(pagination?.total || 1);
  const totalItems = useMemo(() => {
    return pagination?.total || 1;
  }, [pagination?.total]);

  const [containerClass, setContainerClass] = useState("data-container");
  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

  // const fetchUsers = useCallback(async (usrId) => {
  //   try {
  //     const response = await axios.get(`${API_URL}/user?id=${usrId}`);
  //     if (response.data.error === false) {
  //       setUsers(response.data.data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching users:", error);
  //   }
  // }, []);

  // useEffect(() => {
  //   fetchUsers(id);
  // }, [fetchUsers, id]);

  useEffect(() => {
    getOverviewList(id, dispatch, page, "", category);
  }, [category, dispatch, id, page]);

  useEffect(() => {
    if (list?.tickets) {
      setTimeout(() => {
        setContainerClass("data-container active");
      }, 300);
    }
  }, [list?.tickets]);

  /*. -JK unused code removed
  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };
  */

  const removeRemediationData = (recordId) => (e) => {
    $.confirm({
      title: "Are you sure?",
      content:
        "Do you really want to remove this from the Remediation List Panel?",
      type: "red",
      buttons: {
        ok: {
          text: "Remove",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            e.preventDefault();
            removeTicket(recordId, id, dispatch, category);
          },
        },
        cancel: function () {},
      },
    });
  };

  const updateTicketFunction = (_id, data) => {
    updateTicket(_id, data, id, dispatch, "", category);
  };

  return (
    <div>
      {list ? (
        <div className={containerClass}>
          <div className="row clearfix no_margin" style={{ marginTop: "20px" }}>
            <div className="col-sm-2"></div>
            <div className="col-sm-9" style={{ padding: "0" }}>
              <div className="row_boxes row_boxes_table">
                {/* Tab Navigation */}
                <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
                  <li className="nav-item">
                    <span
                      className={`nav-table-tab nav-link ${
                        category === "all" ? "active" : ""
                      }`}
                      onClick={() => {
                        setCategory("all");
                        setPage(1);
                        getOverviewList(id, dispatch, 1, "", "");
                      }}
                    >
                      Overview
                    </span>
                  </li>
                  {/* <li className="nav-item">
                    <span
                      className={`nav-table-tab nav-link ${
                        category === "Open" ? "active" : ""
                      }`}
                      onClick={() => {
                        setCategory("Open");
                        setPage(1);
                        getOverviewList(id, dispatch, 1, "", "Open");
                      }}
                    >
                      Open
                    </span>
                  </li> */}
                  <li className="nav-item">
                    <span
                      className={`nav-link nav-table-tab ${
                        category === "InProgress" ? "active" : ""
                      }`}
                      onClick={() => {
                        setCategory("InProgress");
                        setPage(1);
                        getOverviewList(id, dispatch, 1, "", "InProgress");
                      }}
                    >
                      In Process
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link nav-table-tab ${
                        category === "RiskAccepted" ? "active" : ""
                      }`}
                      onClick={() => {
                        setCategory("RiskAccepted");
                        setPage(1);
                        getOverviewList(id, dispatch, 1, "", "RiskAccepted");
                      }}
                    >
                      Risk Accepted
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link nav-table-tab ${
                        category === "FalsePositive" ? "active" : ""
                      }`}
                      onClick={() => {
                        setCategory("FalsePositive");
                        setPage(1);
                        getOverviewList(id, dispatch, 1, "", "FalsePositive");
                      }}
                    >
                      False Positive
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link nav-table-tab ${
                        category === "Close" ? "active" : ""
                      }`}
                      onClick={() => {
                        setCategory("Close");
                        setPage(1);
                        getOverviewList(id, dispatch, 1, "", "Close");
                      }}
                    >
                      Remediated
                    </span>
                  </li>
                </ul>
                <div className="table_box">
                  <table className="table">
                    <thead>
                      <tr>
                        {/* {auth?.accessLevel != "Threat Analyst" &&
                          (category === "all" ||
                            category === "risk-accepted" ||
                            category === "false-positive") && (
                            <th>
                              <input
                                type="checkbox"
                                checked={
                                  selectedIds == 0 ? false : multiCheckTrue
                                }
                                onClick={() => {
                                  // multicheck(currentTableData);
                                }}
                                className="checkUncheck"
                              />
                            </th>
                          )} */}

                        <th>
                          {auth?.accessLevel != "Threat Analyst" &&
                            (category === "all" ||
                              category === "risk-accepted" ||
                              category === "false-positive") && (
                              <input
                                type="checkbox"
                                checked={
                                  selectedIds == 0 ? false : multiCheckTrue
                                }
                                onClick={() => {
                                  // multicheck(currentTableData);
                                }}
                                className="checkUncheck"
                              />
                            )}
                        </th>
                        <th>Date Added</th>
                        <th>Task Id</th>
                        <th>Type</th>
                        <th>Details</th>
                        <th>Notes</th>
                        <th>Rating</th>
                        <th>Priority</th>
                        <th>Task</th>
                        <th>Assigned</th>
                        <th>Status</th>
                        <th>Due Date</th>
                        <th>Last Updated</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {list?.tickets?.map((r) => {
                        return (
                          <>
                            <tr>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={
                                    selectedIds == 0 ? false : multiCheckTrue
                                  }
                                  onClick={() => {
                                    // multicheck(currentTableData);
                                  }}
                                  className="checkUncheck"
                                />
                              </td>
                              <td>
                                {r?.createdAt
                                  ? moment(r?.createdAt).format("DD-MM-YYYY")
                                  : "NA"}
                              </td>
                              <td>{r?.taskId || "N/A"}</td>
                              {/* <td>{r?.actionType || "N/A"}</td> */}
                              <td>
                                {r?.findingDetails?.specificInfo || "N/A"}
                              </td>
                              <td>{r?.findingDetails?.detail || "N/A"}</td>
                              <td>{r?.note || "N/A"}</td>
                              <td>
                                <div className="select-box">
                                  <select
                                    className="select_box_mytask"
                                    value={r?.rating}
                                    onChange={(e) => {
                                      //  setRating(e.target.value); -- JK : Removed Unused
                                      let data = {
                                        rating: e.target.value,
                                        organisationId: id,
                                      };
                                      updateTicketFunction(r?.recordId, data);
                                    }}
                                  >
                                    <option value="">Please select</option>
                                    <option value="Low">Low</option>
                                    <option value="Medium">Medium</option>
                                    <option value="High">High</option>
                                  </select>
                                  <div className="select_box_img">
                                    <img src={imgselect} alt="" />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="select-box">
                                  <select
                                    className="select_box_mytask"
                                    value={r?.priority}
                                    onChange={(e) => {
                                      // setRating(e.target.value); -- JK : Removed Unused
                                      let data = {
                                        priority: e.target.value,
                                        organisationId: id,
                                      };
                                      updateTicketFunction(r?.recordId, data);
                                    }}
                                  >
                                    <option value="">Please select</option>
                                    <option value="Low">Low</option>
                                    <option value="Medium">Medium</option>
                                    <option value="High">High</option>
                                  </select>
                                  <div className="select_box_img">
                                    <img src={imgselect} alt="" />
                                  </div>
                                </div>
                              </td>
                              <TaskNAssignee
                                item={r}
                                updateTicketFunction={updateTicketFunction}
                                OrgId={id}
                                imgselect={imgselect}
                              />
                              {/*. - JK : We make subcomponent for this. We need to fetch users from API based on the task item selected 
                              <td>
                                <div className="select-box">
                                  <select
                                    className="select_box_mytask"
                                    value={r?.task}
                                    onChange={(e) => {
                                      //  setRating(e.target.value); -- JK : Removed Unused
                                      let data = {
                                        task: e.target.value,
                                        organisationId: id,
                                      };
                                      updateTicketFunction(r?.recordId, data);
                                    }}
                                  >
                                    <option value="">Please select</option>
                                    <option value="External">
                                      External Task
                                    </option>
                                    <option value="Internal">
                                      Internal Task
                                    </option>
                                    <option value="Ticket">Ticket</option>
                                  </select>
                                  <div className="select_box_img">
                                    <img src={imgselect} alt="" />
                                  </div>
                                </div>
                              </td>
                              
                              
                              <td>
                                <div className="select-box">
                                  <select
                                    className="select_box_mytask"
                                    value={r?.assignedTo || ""}
                                    onChange={(e) => {
                                      let data = {
                                        assignedTo: e.target.value,
                                        organisationId: id,
                                      };
                                      updateTicketFunction(r?.recordId, data);
                                    }}
                                  >
                                    <option value="">Please select</option>
                                    {users.map((user) => (
                                      <option key={user._id} value={user._id}>
                                        {user.fullName} ({user.email})
                                      </option>
                                    ))}
                                  </select>
                                  <div className="select_box_img">
                                    <img src={imgselect} alt="" />
                                  </div>
                                </div>
                              </td> */}
                              <td>
                                <div className="select-box">
                                  <select
                                    className="select_box_mytask"
                                    value={r?.status}
                                    onChange={(e) => {
                                      let data = {
                                        status: e.target.value,
                                        organisationId: id,
                                      };
                                      updateTicketFunction(r?.recordId, data);
                                    }}
                                  >
                                    <option value="">Please select</option>
                                    <option value="Open">Open</option>
                                    <option value="InProgress">
                                      In Progress
                                    </option>
                                    <option value="RiskAccepted">
                                      Risk Accepted
                                    </option>
                                    <option value="FalsePositive">
                                      False Positive
                                    </option>
                                    <option value="Close">Remediated</option>
                                  </select>
                                  <div className="select_box_img">
                                    <img src={imgselect} alt="" />
                                  </div>
                                </div>
                              </td>
                              <td>
                                {/* {r?.dueDate
                              ? moment(r?.dueDate).format(
                                "DD-MM-YYYY"
                              ) : "NA"} */}
                                {/* <input className="mdb-datatable-filter flex-row" type="date" /> */}
                                <DatePicker
                                  selected={
                                    r?.dueDate == null
                                      ? ""
                                      : new Date(r?.dueDate)
                                  }
                                  onChange={(date) => {
                                    let data = {
                                      dueDate: date,
                                      organisationId: id,
                                    };
                                    updateTicketFunction(r?.recordId, data);
                                  }}
                                  className="mdb-datatable-filter flex-row datePickerCustomCss"
                                  placeholderText="Select a date"
                                  dateFormat="yyyy-MM-dd"
                                />
                              </td>
                              <td>
                                {r?.updatedAt
                                  ? moment(r?.updatedAt).format("DD-MM-YYYY")
                                  : "NA"}
                              </td>
                              <td>
                                <span
                                  className="openTask"
                                  onClick={() => {
                                    setSelectedTask(r);
                                    setIsPopupOpen(true);
                                  }}
                                >
                                  Open Task
                                </span>
                              </td>
                              <RemediationActionButton
                                onRemove={() =>
                                  removeRemediationData(r?.recordId)
                                }
                                shouldShowPlus={false}
                              />
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="dataTables_paginate">
                {console.log(totalItems, "totalItems")}
                {totalItems > 0 && (
                  <Pagination
                    className="pagination-bar"
                    currentPage={page}
                    totalCount={totalItems}
                    pageSize={10}
                    onPageChange={(page) => setPage(page)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
      {isPopupOpen && (
        <EditTaskPopup
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          taskData={selectedTask}
        />
      )}
    </div>
  );
};

export default memo(RemediationOverview);
